import { createInjectionKey } from "../../_utils/index.mjs";
export const dialogProviderInjectionKey = createInjectionKey('n-dialog-provider');
export const dialogApiInjectionKey = createInjectionKey('n-dialog-api');
export const dialogReactiveListInjectionKey = createInjectionKey('n-dialog-reactive-list');